let language = localStorage.getItem("lng") || "id";

export const initialState = {
  language: language,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LANGUAGE":
      return {
        ...state,
        language: action.payload.language,
      };
    default:
      return state;
  }
};
